//cart
export const TOGGLE_CART = "TOGGLE_CART";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const EDIT_HOME_OBJ = "EDIT_HOME_OBJ";
export const SET_UN_PRELOAD = "SET_UN_PRELOAD";
export const SET_PRELOAD = "SET_PRELOAD";

//user
export const UPDATE_STATION_ID = "UPDATE_STATION_ID";

//user
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const JWT_UPDATED = "JWT_UPDATED";
export const USER_ENTRY = "USER_ENTRY";
export const VERIFIED_EMAIL = "VERIFIED_EMAIL";
export const SET_EMAIL_VERIFICATION_DISMISSED =
  "SET_EMAIL_VERIFICATION_DISMISSED";
export const SET_TEMP_ADDRESS = "SET_TEMP_ADDRESS";
export const UPDATE_USER = "UPDATE_USER";

//category
export const SET_ALL_CATEGORY = "SET_ALL_CATEGORY";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const SET_IMG = "SET_IMG";
export const TOGGLE_EXPAND_CARD = "TOGGLE_EXPAND_CARD";
export const RESET_EXPANDED_CARDS = "RESET_EXPANDED_CARDS";
export const SET_EXPANDED_CARDS = "SET_EXPANDED_CARDS";
export const UPDATE_CATEGORY_BRANCH = "UPDATE_CATEGORY_BRANCH";
export const SET_CURRENT_CATEGORY = "SET_CURRENT_CATEGORY";
export const SET_CLIENT_VIEW = "SET_CLIENT_VIEW";
export const SET_STATUS = "SET_STATUS";

// productsInCart

export const ADD_PRODUCT_IN_CART = "ADD_PRODUCT_IN_CART";
export const SET_ALL_PRODUCT = "SET_ALL_PRODUCT";
export const SET_REVALIDATED_PRODUCTS = "SET_REVALIDATED_PRODUCTS";
export const CANCEL_ERROR = "CANCEL_ERROR";
export const CLEAR_CARD = "CLEAR_CARD";
export const SET_DELIVERY_PRICE = "SET_DELIVERY_PRICE";
export const SET_MIN_ORDER = "SET_MIN_ORDER";
export const SET_ORDER_FOR_FREE = "SET_ORDER_FOR_FREE";
export const SET_COUPON_DISCOUNT = "SET_COUPON_DISCOUNT";
export const OPTIMISTIC_CART_UPDATE = "OPTIMISTIC_CART_UPDATE";
export const CONFIRM_CART_UPDATE = "CONFIRM_CART_UPDATE";
export const ROLLBACK_CART_UPDATE = "ROLLBACK_CART_UPDATE";
export const CART_ITEM_SYNC_START = "CART_ITEM_SYNC_START";
export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";

//displayProduct
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SORT_PRODUCTS = "SORT_PRODUCTS";
export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT";
export const TOGGLE_FILTER = "TOGGLE_FILTER";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const RELOED = "RELOED";

export const SET_SEARCH_PRODUCT = "SET_SEARCH_PRODUCT";
export const DELETE_SEARCH = "DELETE_SEARCH";

export const SET_FILTER_SORT = "SET_FILTER_SORT";
export const SET_SORT_KEY = "SET_SORT_KEY";
export const SET_CATEGORY_FILTERS = "SET_CATEGORY_FILTERS";
export const CLEAR_CATEGORY_FILTERS = "CLEAR_CATEGORY_FILTERS";
export const SET_CATEGORY_ITEMS_SOURCE = "SET_CATEGORY_ITEMS_SOURCE";

//shoppingList
export const SET_SHOP_LIST = "SET_SHOP_LIST";
export const SET_SHOP_LIST_LOADING = "SET_SHOP_LIST_LOADING";
export const ADD_NEW_SHOP_LIST = "ADD_NEW_SHOP_LIST";
export const DELETE_SHOP_LIST = "DELETE_SHOP_LIST";
export const UPDATE_SHOP_LIST_NAME = "UPDATE_SHOP_LIST_NAME";

// selectedProduct
export const SET_SELCTED_PRODUCT = "SET_SELCTED_PRODUCT";
export const SET_UNSELCTED_PRODUCT = "SET_UNSELCTED_PRODUCT";
export const SET_PRODUCT_CATEGORIES = "SET_PRODUCT_CATEGORIES";
export const SET_PRODUCT_PRICING = "SET_PRODUCT_PRICING";
export const SET_ALL_SELECTED_PRODUCT = "SET_ALL_SELECTED_PRODUCT";

//productFilters
export const SET_FILTERS = "SET_FILTERS";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const SET_STATUS_FILTER = "SET_STATUS_FILTER";
export const SET_BASE_PRODUCTS = "SET_BASE_PRODUCTS";
export const SET_CATEGORY_CHIPS = "SET_CATEGORY_CHIPS";
export const ADD_CATEGORY_CHIP = "ADD_CATEGORY_CHIP";
export const REMOVE_CATEGORY_CHIP = "REMOVE_CATEGORY_CHIP";
export const UPDATE_CATEGORY_CHIP = "UPDATE_CATEGORY_CHIP";
export const SET_EXTRA_COLUMNS = "SET_EXTRA_COLUMNS";
export const RELOAD = "RELOAD";
